// @flow
import React, { useState } from 'react';
import TherapistsList from './CATherapistsList';
import { noop } from 'react-bootstrap-typeahead/types/utils';
type Props = {
    choices?: any,
    className?: string,
    list: Array<Object>,
    dateRequested: Array<string>,
    userData: Object,
    loadMoreResult: Function,
    offset: number,
    setOffset: Function,
    handleSliderDateChange: Function,
    isFloating: Function,
    isFetching: boolean,
    onPageChange: Function,
    totalPages: Number,
    currentPage: Number,
    selectedUserId: String,
    updateSlot:Function,
    handleOnclick:Function,
    selectedFilters: Object,
    handleLaterSlot:Function,
    setIsMatchAssistance?: (isMatchAssistance: boolean) => void,
};

export default function CATherapistsListContainer({
    choices,
    className = "",
    list,
    dateRequested,
    userData,
    loadMoreResult,
    offset,
    setOffset,
    handleSliderDateChange,
    isFloating,
    isFetching,
    onPageChange,
    totalPages,
    currentPage,
    selectedUserId,
    updateSlot,
    handleOnclick,
    selectedFilters,
    handleLaterSlot,
    setIsMatchAssistance = noop,
}: Props): React$Element<any> {
    // const history = useNavigate();
    const [currentFocus, setCurrentFocus] = useState(null);

    return (
        <TherapistsList
            choices={choices}
            className={className}
            list={list}
            dateRequested={dateRequested}
            setCurrentFocus={setCurrentFocus}
            currentFocus={currentFocus}
            loadMoreResult={loadMoreResult}
            offset={offset}
            setOffset={setOffset}
            selectedUserData={userData}
            sliderDateChange={handleSliderDateChange}
            isFloating={isFloating}
            isFetching={isFetching}
            onPageChange={onPageChange}
            totalPages={totalPages}
            currentPage={currentPage}
            selectedUserId={selectedUserId}
            updateSlot={updateSlot}
            handleOnclick={handleOnclick}
            selectedFilters={selectedFilters}
            handleLaterSlot={handleLaterSlot}
            setIsMatchAssistance={setIsMatchAssistance}
        />
    );
}
